import axiosInstance from "global/helpers/axiosInstance";
import {
  REGISTRO_SUCCESS,
  REGISTRO_LOADING,
  REGISTRO_ERROR,
  REGISTRO_SETUSUARIO,
  REGISTRO_SETERRORUSUARIO,
} from "../../ActionTypes";

export const setUsuario = (usuario) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETUSUARIO,
    payload: usuario,
  });
};

export const setListError = (listError) => (dispatch) => {
  dispatch({
    type: REGISTRO_SETERRORUSUARIO,
    payload: listError,
  });
};

export const registro = (usuario) => (dispatch) => {
  dispatch({
    type: REGISTRO_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`/registro`, usuario)
      .then((res) => {
        dispatch({
          type: REGISTRO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: REGISTRO_ERROR,
          payload: error,
        });
      });
  });
};

export const resetErrorReg = () => (dispatch) => {
  dispatch({
    type: REGISTRO_ERROR,
    payload: null,
  });
};
